import type { AuthToken } from '@/api/authProxy/types';
import { authProxyGetToken } from '@/api/authProxy/service';
import config from '@/config';
import { useStore } from '@/store';

export const getValidToken = async (): Promise<AuthToken> => {
  const store = useStore();
  const now = Date.now();
  const token = store.authProxyToken;

  const invalidToken = (token?: AuthToken): boolean => {
    if (!token || !token.access_token) return true;
    const issuedAt = token.issued_at ?? 0;
    const expiresInMs = (token.expires_in ?? 0) * 1000; // convert to MS
    const expiresAt = issuedAt + expiresInMs;
    const bufferMs = 60000; // 1 minute buffer
    return expiresAt - bufferMs <= now;
  };

  if (invalidToken(token)) {
    const { clientId, clientSecret } = config.services.credentials;
    const postData = { scope: [], clientId, clientSecret };

    const newToken = await authProxyGetToken(postData);
    store.authProxyToken = {
      ...newToken,
      issued_at: now,
    };
  }

  const validToken = store.authProxyToken;

  if (!validToken || !validToken.access_token) {
    throw new Error('Auth Token Error');
  }

  return validToken;
};
